export default function About() {
  return (
    <section id="sobre-kebabish" className="py-24 px-6 lg:px-20 bg-[#E63946]">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className="relative h-[500px] rounded-[32px] overflow-hidden">
            <img
              src="https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/31e4fa84f29c6223af91e75be04f9cc7.png"
              alt="Kebabish Kebab"
              className="w-full h-full object-cover"
            />
          </div>

          {/* Content */}
          <div>
            <div className="inline-block bg-white/20 px-4 py-2 rounded-full mb-6">
              <p className="text-white font-semibold text-sm">SOBRE NOSOTROS</p>
            </div>
            
            <h2 className="text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
              Sabor auténtico en <span className="text-white">Pozuelo</span>
            </h2>
            
            <p className="text-xl text-white leading-relaxed mb-6">
              En <strong>Kebabish Kebab</strong> somos especialistas en kebabs, durums y pollo frito. Cada plato se prepara al momento con ingredientes frescos y de calidad.
            </p>
            
            <p className="text-xl text-white leading-relaxed mb-8">
              Perfecto para comer en casa, recoger tu pedido o disfrutar de nuestro servicio a domicilio gratuito. Llevamos años siendo el restaurante favorito de las familias de Pozuelo de Alarcón.
            </p>

            <div className="flex flex-wrap gap-6">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center">
                  <i className="ri-restaurant-2-line text-gray-900 text-xl"></i>
                </div>
                <div>
                  <p className="font-bold text-white">Ingredientes Frescos</p>
                  <p className="text-white/90 text-sm">Calidad garantizada</p>
                </div>
              </div>

              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center">
                  <i className="ri-time-line text-gray-900 text-xl"></i>
                </div>
                <div>
                  <p className="font-bold text-white">Servicio Rápido</p>
                  <p className="text-white/90 text-sm">Pedidos en minutos</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}